import http from "../../services/http";

const path = "api/chapter";

const bookChapters = ({ onSuccess, onError, onEnd, id = "" }) => {
  return async (dispatch, getState) => {
    try {
      const store = getState();
      const res = await http.get({
        url: path + `/bybook/${id}`,
        headers: {
          "x-auth-token": store.auth.token,
        },
      });
      if (onSuccess) onSuccess(res);
    } catch (error) {
      if (onError) onError(error);
    } finally {
      if (onEnd) onEnd();
    }
  };
};

export { bookChapters };
